import { SERVICE_NAME } from "@/config/serviceNames";
import { requests } from ".";

interface listDomainsParams {
  locationId: string;
}
interface DeleteDomain {
  domainId: string;
  locationId: string;
}

interface DowngradeFunnel {
  funnelId: string;
}

interface GetDeletedFunnels {
  locationId: string;
}

interface RestoreFunnel {
  locationId: string;
  funnelId: string;
}
interface RestoreFunnelsByLocation {
  locationId: string;
}

interface SwitchFunnelType {
  funnelId: string;
  locationId: string;
  type: string;
}
interface GetDeletedFunnelPagesParams {
  locationId: string;
  funnelId: string;
}
interface RestoreFunnelPagesParams {
  locationId: string;
  pageId: string;
}
interface DomainLogsParam {
  domain: string;
}

interface GenerateLevel0CertParams {
  domain: string;
}

const FunnelsServices = {
  listDomains: (params: listDomainsParams) =>
    requests(SERVICE_NAME.FUNNELS_API).get("domain", {
      params,
    }),

  deleteDomain: (params: DeleteDomain) =>
    requests(SERVICE_NAME.FUNNELS_API).delete("domain", {
      params,
    }),

  downgradeFunnel: (params: DowngradeFunnel) =>
    requests(SERVICE_NAME.FUNNELS_API).post("funnel/downgrade", params),

  getDeletedFunnel: (params: GetDeletedFunnels) =>
    requests(SERVICE_NAME.FUNNELS_API).get("funnel/deleted-funnels", {
      params,
    }),

  restoreFunnel: (params: RestoreFunnel) =>
    requests(SERVICE_NAME.FUNNELS_API).post("funnel/restore-funnels", params),

  getDeletedFunnelPages: (params: GetDeletedFunnelPagesParams) =>
    requests(SERVICE_NAME.FUNNELS_API).get("funnel/deleted-pages", {
      params,
    }),

  restorePage: (params: RestoreFunnelPagesParams) =>
    requests(SERVICE_NAME.FUNNELS_API).post("funnel/restore-page", params),

  restoreFunnelsByLocation: (params: RestoreFunnelsByLocation) =>
    requests(SERVICE_NAME.FUNNELS_API).post(
      "funnel/restore-funnels-location",
      params
    ),

  switchFunnelType: (params: SwitchFunnelType) =>
    requests(SERVICE_NAME.FUNNELS_API).post("funnel/switch-type", params),

  fetchDomainLogs: (params: DomainLogsParam) =>
    requests(SERVICE_NAME.FUNNELS_API).get("domain/logs", {
      params,
    }),

  regenerateLevel0Cert: (params: GenerateLevel0CertParams) =>
    requests(SERVICE_NAME.FUNNELS_API).post("domain/validate-recreate", params),
};
export default FunnelsServices;
